import { IOptionsSelect } from "components/Inputs/interfaces/options.interface";
  
export function generateInstallments(
  totalAmount: number,
  maxInstallments: number = 12,
  quantityToOnDemand: number = 1,
  interestRate: number = 0 // Taxa de juros em % ao mês (0 para sem juros)
): IOptionsSelect[] {
  const installments: IOptionsSelect[] = [];

  const formatValue = (value: number) => {
    const valueFormatted = parseFloat(value.toFixed(2)).toFixed(2).toString().replace(".", ",");
    return valueFormatted;
  };
  
  for (let i = 1; i <= maxInstallments; i++) {
    let total = totalAmount * quantityToOnDemand;

    // Se houver juros, calcula o valor total parcelado
    if (interestRate > 0 && i > 1) {
      const monthlyRate = interestRate / 100;
      total = totalAmount * Math.pow(1 + monthlyRate, i);
    }
  
    // Calcula o valor de cada parcela
    const installmentValue = total / i;
  
    // Adiciona ao array de opções
    installments.push({
      value: i,
      label: `${i}x: R$ ${formatValue(installmentValue)}, total R$ ${formatValue(total)} `,
    });
  }
  
  return installments;
}
  